@if (availableGroups.length) {
  <div
    class="grid-groups-wrapper"
    [ngClass]="{'collapsable' : shouldShowExpandButton()}">
    <div class="grid-groups"
       [ngClass]="{'collapsed' : !areGroupsExpanded,
                  'expanded' : areGroupsExpanded }">
      @for (group of availableGroups; track trackByFn($index, group)) {
        <scitis-dashboard-group-item
          [group]="group">
        </scitis-dashboard-group-item>
      }
    </div>
    @if (shouldShowExpandButton()) {
      <span class="group-expand-button"
        (click)="onSwitchGroupExpandedState()"
        [ngClass]="{'collapsed' : !areGroupsExpanded,
                   'expanded' : areGroupsExpanded }">
        <em class="fa-solid fa-angles-down"></em>
      </span>
    }
  </div>
}
